import { render, staticRenderFns } from "./project-add2.vue?vue&type=template&id=9fce3ed2&scoped=true&"
import script from "./project-add2.vue?vue&type=script&lang=js&"
export * from "./project-add2.vue?vue&type=script&lang=js&"
import style0 from "./project-add2.vue?vue&type=style&index=0&id=9fce3ed2&prod&lang=scss&"
import style1 from "./project-add2.vue?vue&type=style&index=1&id=9fce3ed2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fce3ed2",
  null
  
)

export default component.exports